module.exports = __webpack_public_path__ + "img/Central-Marine-Fisheries-Research-Institute-(CMFRI).a8982a16.jpg";